import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

export default function FormCol({ className, children }) {
  return <div className={clsx('col-12', className)}>{children}</div>
}

FormCol.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}
